import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { StarRating } from "./StarRating/StarRating";
import { setPingSessionRating } from "../Api/PingSessionApi";

export const SessionSummary = ({ session, onClose, showSpeedColors, onToggleSpeedColors }) => {
    const navigate = useNavigate();
    const [rating, setRating] = useState(session.rating);

    useEffect(() => {
        setRating(session.rating);
    }, [session.pingSessionId, session.rating]);

    const handleRate = (newRating) => {
        const previousRating = rating;
        setRating(newRating);
        setPingSessionRating(session.pingSessionId, newRating).catch(() => {
            setRating(previousRating);
        });
    };

    return (



        <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true" className="session-summary">
            <div className="toast-header">
                <strong className="me-auto">Session Summary</strong>
            </div>
            <div className="toast-body">
                <Form.Check
                    type="switch"
                    id="speed-color-toggle"
                    label="Colour points by speed"
                    checked={showSpeedColors}
                    onChange={(e) => onToggleSpeedColors(e.target.checked)}
                />
                <p><strong>Total Pings:</strong> {session.pings.length}</p>
                <p><strong>Origin:</strong> {session.originLocationDescription}</p>
                <p><strong>Destination:</strong> {session.destinationLocationDescription ?? "N/A"}</p>
                <p><strong>Start Time:</strong> {session.createDateDisplay}</p>
                <p><strong>End Time:</strong> {session.endDateDisplay ?? "N/A"}</p>
                <p><strong>Created By:</strong> {session.username}</p>
                <p>
                    <strong>Rating:</strong>{" "}
                    <StarRating rating={rating} onRate={handleRate} readOnly={session.isOverwatchBonded} />
                </p>
                <Button size="sm" variant="primary" onClick={() => navigate(`/sessions/${session.pingSessionId}/timeline`, { state: { pingSession: session } })}>
                    View Timeline
                </Button>
            </div>
        </div>
    );
}